export var SelectedFilter;
(function (SelectedFilter) {
    SelectedFilter["ALL"] = "all";
    SelectedFilter["STORE"] = "store";
    SelectedFilter["SELLER"] = "seller";
    SelectedFilter["CAMPAIGN"] = "campaign";
    SelectedFilter["CLUSTER"] = "cluster";
})(SelectedFilter || (SelectedFilter = {}));
